// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1861":"b9c93ac0","2471":"ae909072","2903":"b8fa6a62","3735":"dbcbad15","4509":"bcbd0059","6924":"14131b19","7664":"bba743e9","8681":"fccb3277","9047":"a9807219","9694":"9785f0e8"}[chunkId] + ".chunk.css";
};